/* eslint-disable */
import { CallContext, CallOptions } from 'nice-grpc-common';
import { Empty } from '../../../../../google/protobuf/empty';
import _m0 from 'protobufjs/minimal';

export const protobufPackage = 'com.celertech.baseserver.communication.protobuf';

export interface ServerConfiguration {
    configurationKey: string;
    configurationValue: string;
}

export interface ServerConfigurationList {
    serverConfig: ServerConfiguration[];
}

function createBaseServerConfiguration(): ServerConfiguration {
    return { configurationKey: '', configurationValue: '' };
}

export const ServerConfiguration = {
    encode(message: ServerConfiguration, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
        if (message.configurationKey !== '') {
            writer.uint32(10).string(message.configurationKey);
        }
        if (message.configurationValue !== '') {
            writer.uint32(18).string(message.configurationValue);
        }
        return writer;
    },

    decode(input: _m0.Reader | Uint8Array, length?: number): ServerConfiguration {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseServerConfiguration();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.configurationKey = reader.string();
                    break;
                case 2:
                    message.configurationValue = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },

    fromPartial(object: DeepPartial<ServerConfiguration>): ServerConfiguration {
        const message = createBaseServerConfiguration();
        message.configurationKey = object.configurationKey ?? '';
        message.configurationValue = object.configurationValue ?? '';
        return message;
    }
};

function createBaseServerConfigurationList(): ServerConfigurationList {
    return { serverConfig: [] };
}

export const ServerConfigurationList = {
    encode(message: ServerConfigurationList, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
        for (const v of message.serverConfig) {
            ServerConfiguration.encode(v!, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },

    decode(input: _m0.Reader | Uint8Array, length?: number): ServerConfigurationList {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseServerConfigurationList();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.serverConfig.push(ServerConfiguration.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },

    fromPartial(object: DeepPartial<ServerConfigurationList>): ServerConfigurationList {
        const message = createBaseServerConfigurationList();
        message.serverConfig = object.serverConfig?.map((e) => ServerConfiguration.fromPartial(e)) || [];
        return message;
    }
};

export type ServerConfigurationServiceDefinition = typeof ServerConfigurationServiceDefinition;
export const ServerConfigurationServiceDefinition = {
    name: 'ServerConfigurationService',
    fullName: 'com.celertech.baseserver.communication.protobuf.ServerConfigurationService',
    methods: {
        getConfigurations: {
            name: 'getConfigurations',
            requestType: Empty,
            requestStream: false,
            responseType: ServerConfigurationList,
            responseStream: false,
            options: {}
        }
    }
} as const;

export interface ServerConfigurationServiceServiceImplementation<CallContextExt = {}> {
    getConfigurations(
        request: Empty,
        context: CallContext & CallContextExt
    ): Promise<DeepPartial<ServerConfigurationList>>;
}

export interface ServerConfigurationServiceClient<CallOptionsExt = {}> {
    getConfigurations(
        request: DeepPartial<Empty>,
        options?: CallOptions & CallOptionsExt
    ): Promise<ServerConfigurationList>;
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin
    ? T
    : T extends Array<infer U>
    ? Array<DeepPartial<U>>
    : T extends ReadonlyArray<infer U>
    ? ReadonlyArray<DeepPartial<U>>
    : T extends {}
    ? { [K in keyof T]?: DeepPartial<T[K]> }
    : Partial<T>;
